/**
 * Catalog copied verbatim from the design prototype.
 * `rc` = rating count. Shape matches what the FastAPI /products response should return.
 *
 * `format` mirrors the real API: books are digital editions read inside playTUB
 * (no delivery), everything else is a printed/physical item that ships. Both
 * paths exist here on purpose so checkout can be exercised without a backend.
 *
 * `currency` likewise mirrors the API, where it comes from each book's own
 * `base_pricing.currency`. The live catalogue is genuinely mixed — publishers
 * price their own books — so one title here is priced in USD to keep the
 * per-currency cart split exercised offline.
 */
export const PRODUCTS = [
  {
    id: 1,
    cat: 'books',
    format: 'digital',
    currency: 'INR',
    name: 'Paper Tides',
    price: 399,
    rating: 4.6,
    rc: 214,
    tag: 'Staff pick',
    desc: 'A quiet, funny novel about a lighthouse keeper who collects letters that were never sent. The kind of book you finish and immediately lend to someone.',
  },
  {
    id: 2,
    cat: 'books',
    format: 'digital',
    currency: 'INR',
    name: "The Cartographer's Cat",
    price: 549,
    rating: 4.8,
    rc: 341,
    tag: 'Bestseller',
    desc: 'Part mystery, part travelogue — a mapmaker follows her missing cat across three continents. Gorgeously illustrated endpapers.',
    // The one title here with language adaptations, projected exactly as
    // book_mapper.to_pricing builds them: the base language, a paid adaptation,
    // a free one, and one the publisher hasn't put on sale (negative price at
    // source, so `available: false`).
    language: 'English',
    additional_languages: ['French', 'Hindi', 'Italian'],
    pricing: {
      is_free: false,
      currency: 'INR',
      one_time_purchase_price: 549,
      additional_language_prices: { French: 99, Hindi: 0 },
      language_options: [
        { language: 'English', price: 549, is_base: true, available: true },
        { language: 'French', price: 99, is_base: false, available: true },
        { language: 'Hindi', price: 0, is_base: false, available: true },
        { language: 'Italian', price: 0, is_base: false, available: false },
      ],
    },
  },
  {
    id: 3,
    cat: 'books',
    format: 'digital',
    currency: 'INR',
    name: 'Small Fires, Big Kitchens',
    price: 799,
    rating: 4.3,
    rc: 128,
    tag: 'New',
    desc: '60 one-pan recipes for tiny kitchens and big appetites. Hardcover, lies flat, survives splatter.',
  },
  {
    id: 4,
    cat: 'books',
    format: 'digital',
    // The one USD title, so a mixed cart is reachable without a backend.
    currency: 'USD',
    name: 'How to Sit Still',
    price: 9,
    rating: 4.1,
    rc: 96,
    tag: 'Cozy',
    desc: 'A pocket-sized field guide to doing absolutely nothing, beautifully. Makes a suspiciously good gift.',
  },
  {
    id: 5,
    cat: 'tshirts',
    format: 'printed',
    currency: 'INR',
    name: 'Cosmic Ramen Tee',
    price: 699,
    rating: 4.7,
    rc: 452,
    tag: 'Fan favorite',
    desc: 'A bowl of ramen orbited by tiny planets. 100% combed cotton, screen printed, pre-shrunk. Unisex fit, S–XXL.',
  },
  {
    id: 6,
    cat: 'tshirts',
    format: 'printed',
    currency: 'INR',
    name: 'Grid Paper Tee',
    price: 649,
    rating: 4.4,
    rc: 187,
    tag: 'Minimal',
    desc: 'For people who think in millimeters. Subtle 5mm grid print across heavyweight off-white cotton.',
  },
  {
    id: 7,
    cat: 'tshirts',
    format: 'printed',
    currency: 'INR',
    name: 'Overthinker Club Tee',
    price: 749,
    rating: 4.6,
    rc: 298,
    tag: 'Bestseller',
    desc: 'Front: "Overthinker Club". Back: "or is it?". Soft-washed black cotton that holds its color.',
  },
  {
    id: 8,
    cat: 'tshirts',
    format: 'printed',
    currency: 'INR',
    name: 'Sunset Gradient Tee',
    price: 699,
    rating: 4.2,
    rc: 143,
    tag: 'Summer',
    desc: 'A hand-pulled gradient from peach to plum, slightly different on every shirt. Yours is one of one.',
  },
  {
    id: 9,
    cat: 'stickers',
    format: 'printed',
    currency: 'INR',
    name: 'Happy Blob Pack (12)',
    price: 199,
    rating: 4.9,
    rc: 611,
    tag: 'Top rated',
    desc: 'Twelve emotionally supportive blobs. Waterproof vinyl, laptop-safe adhesive, survives dishwashers and deadlines.',
  },
  {
    id: 10,
    cat: 'stickers',
    format: 'printed',
    currency: 'INR',
    name: 'Laptop Botanicals Pack',
    price: 249,
    rating: 4.5,
    rc: 234,
    tag: 'Pretty',
    desc: 'Eight pressed-flower style stickers for turning any laptop lid into a tiny greenhouse.',
  },
  {
    id: 11,
    cat: 'stickers',
    format: 'printed',
    currency: 'INR',
    name: 'Retro Weather Icons',
    price: 179,
    rating: 4.3,
    rc: 156,
    tag: 'Retro',
    desc: 'Ten weather icons in a 1970s field-guide style. The lightning bolt is everyone’s favorite.',
  },
  {
    id: 12,
    cat: 'stickers',
    format: 'printed',
    currency: 'INR',
    name: 'Tiny Astronauts Pack',
    price: 229,
    rating: 4.6,
    rc: 322,
    tag: 'Space',
    desc: 'Six astronauts doing everyday things — grocery shopping, walking a dog, drinking chai — in zero gravity.',
  },
  {
    id: 13,
    cat: 'figurines',
    format: 'printed',
    currency: 'INR',
    name: 'Desk Buddy: Moon Cat',
    price: 1299,
    rating: 4.8,
    rc: 389,
    tag: 'Handmade',
    desc: 'A hand-cast resin cat curled on a crescent moon. 9cm tall, matte finish, judges your posture silently.',
  },
  {
    id: 14,
    cat: 'figurines',
    format: 'printed',
    currency: 'INR',
    name: 'Tiny Torii Gate',
    price: 999,
    rating: 4.5,
    rc: 167,
    tag: 'Zen',
    desc: 'A vermilion torii gate in kiln-fired ceramic. Instantly makes any shelf 40% more serene.',
  },
  {
    id: 15,
    cat: 'figurines',
    format: 'printed',
    currency: 'INR',
    name: 'Pocket Dino — Steggy',
    price: 899,
    rating: 4.7,
    rc: 275,
    tag: 'Cute',
    desc: 'A palm-sized stegosaurus in sage green stoneware. Part of the Pocket Dino series; collect all five.',
  },
  {
    id: 16,
    cat: 'figurines',
    format: 'printed',
    currency: 'INR',
    name: 'Brass Paper Crane',
    price: 1499,
    rating: 4.9,
    rc: 203,
    tag: 'Premium',
    desc: 'A solid brass origami crane, folded in metal. Ages into a beautiful patina; heavy enough to hold down big ideas.',
  },
  {
    id: 17,
    cat: 'posters',
    format: 'printed',
    currency: 'INR',
    name: 'Kyoto at Dusk — A2',
    price: 899,
    rating: 4.7,
    rc: 318,
    tag: 'Bestseller',
    desc: 'A risograph-style print of lantern-lit backstreets. Printed on 250gsm matte stock; ships in a sturdy tube.',
  },
  {
    id: 18,
    cat: 'posters',
    format: 'printed',
    currency: 'INR',
    name: 'Type Specimen No.4 — A3',
    price: 649,
    rating: 4.4,
    rc: 142,
    tag: 'For nerds',
    desc: 'Every glyph of a forgotten 1962 grotesque, lovingly re-set. Designers stare at this for uncomfortable lengths of time.',
  },
  {
    id: 19,
    cat: 'posters',
    format: 'printed',
    currency: 'INR',
    name: 'Ocean Contours — A2',
    price: 949,
    rating: 4.6,
    rc: 189,
    tag: 'Calm',
    desc: 'Bathymetric lines of the Indian Ocean in six shades of blue. Deep in every sense.',
  },
  {
    id: 20,
    cat: 'posters',
    format: 'printed',
    currency: 'INR',
    name: 'Mid-century Kitchen — A3',
    price: 699,
    rating: 4.2,
    rc: 117,
    tag: 'Retro',
    desc: 'A sunny illustrated kitchen circa 1958, complete with a cat on the fridge. Warm tones, matte finish.',
  },
];
